// src/pages/ReportsPage.js
import React from 'react';
import { Container, Typography, Grid } from '@mui/material';
import MasterParticipantReport from '../components/MasterParticipantReport';
import DailyAttendanceReport from '../components/DailyAttendanceReport';
import ExcursionBookingReport from '../components/ExcursionBookingReport';

const ReportsPage = () => {
  return (
    <Container maxWidth="xl">
      <Typography variant="h4" gutterBottom>
        Event Reports
      </Typography>
      
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <MasterParticipantReport />
        </Grid>
        <Grid item xs={12} md={6}>
          <DailyAttendanceReport />
        </Grid>
        <Grid item xs={12} md={6}>
          <ExcursionBookingReport />
        </Grid>
      </Grid>
    </Container>
  );
};

export default ReportsPage;